<template>
	<div>
		<AdminHeader />
		<AdminNavSideBar class="absolute top-0 hidden w-80 md:block" />
		<slot />
	</div>
</template>
